export const CUSTOM_ERRORS = {
  COMMON_ERROR: 'Something went wrong. Try again.',
}

export const handleAPIError = (err) => {
  const response = {
    success: false,
    code: null,
    message: null,
  };
  if (err?.response?.data?.error) {
    response.message = err.response.data.error?.message;
    response.code = err.response.data.error?.code;
  } else {
    response.message = CUSTOM_ERRORS.COMMON_ERROR;
  }
  return response;
}